import { createStore, createTypedHooks, Action, action } from "easy-peasy";

import { IUserType, userModel } from "./userModel";

interface IAppStore {
  userModel: IUserType;

  isWidgetsConfigDone: boolean;
  finishWidgetsConfig: Action<IAppStore>;
  isOpenDeepSeek: boolean;
  setIsOpenDeepSeek: Action<IAppStore, boolean>;
  /**埋点初始化是否完成*/
  finishTrack: boolean;
  setFinishTrack: Action<IAppStore, boolean>;
  isOpenPptCommercialization:
    | {
        isHitGroupOne: boolean;
        isHitGroupTwo: boolean;
      }
    | undefined;
  setIsOpenPptCommercialization: Action<
    IAppStore,
    {
      isHitGroupOne: boolean;
      isHitGroupTwo: boolean;
    }
  >;
}

const store = createStore<IAppStore>({
  userModel,
  isWidgetsConfigDone: false,
  finishWidgetsConfig: action((state) => {
    state.isWidgetsConfigDone = true;
  }),
  isOpenDeepSeek: true,
  setIsOpenDeepSeek: action((state, payload) => {
    state.isOpenDeepSeek = payload;
  }),
  finishTrack: false,
  setFinishTrack: action((state, payload) => {
    state.finishTrack = payload;
  }),
  isOpenPptCommercialization: undefined,
  setIsOpenPptCommercialization: action((state, payload) => {
    state.isOpenPptCommercialization = payload;
  }),
});

const typedHooks = createTypedHooks<IAppStore>();
export const useStoreState = typedHooks.useStoreState;
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;

export default store;
